import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'card',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'REMOVE_MATCH',
    })
  }
}
